import {
  useCreateAdminKycLinkMutation,
  AliceCardKycStatus,
  OrganizationDetailFragment,
} from '@alice-financial/alice-sdk'
import { Button, ButtonProps } from '@alice-financial/pretext-ui'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

const KYCButtonLabel = ({ status }: { status?: AliceCardKycStatus }): JSX.Element => {
  switch (status) {
    case AliceCardKycStatus.Complete:
      return <FormattedMessage id="org.alice_card.kyc.complete_label" />
    case AliceCardKycStatus.Started:
      return <FormattedMessage id="org.alice_card.kyc.continue_label" />
    case AliceCardKycStatus.Pending:
      return <FormattedMessage id="org.alice_card.kyc.pending_verification_label" />
    default:
      return <FormattedMessage id="org.alice_card.kyc.start_label" />
  }
}

type KYCStepsProps = {
  org: OrganizationDetailFragment
} & ButtonProps
export const KYCButton = ({ org, sx = {}, ...buttonProps }: KYCStepsProps) => {
  const {
    mutate: fetchKycLink,
    isLoading,
    isSuccess,
  } = useCreateAdminKycLinkMutation({
    onSuccess: (kycLinkData) => {
      if (!kycLinkData.createAdminKycLink?.adminKycLink) throw new Error('Invalid KYC link')
      window.location.assign(kycLinkData.createAdminKycLink?.adminKycLink)
    },
  })

  const kycStatus = org.aliceCardProgram?.kycStatus
  const isComplete = kycStatus === AliceCardKycStatus.Complete
  const isDisabled = isLoading || isSuccess || isComplete

  return (
    <Button
      variant="contained"
      onClick={() => fetchKycLink({ orgId: org.id })}
      disabled={isDisabled}
      endIcon={isComplete ? undefined : <ArrowForwardIosIcon />}
      {...buttonProps}
      sx={{ textWrap: 'nowrap', ...sx }}
    >
      <KYCButtonLabel status={kycStatus} />
    </Button>
  )
}
